module.exports = __webpack_public_path__ + "img/78000.e278d4ea.jpg";